export class LotCodeDropDown{
    lotCodeOpsId?:number;
    lotNumber:string;
    subLotNumber?:string;


    /**
     * 
     * @param lotCodeOpsId 
     * @param lotNumber 
     */
    constructor(lotNumber:string, subLotNumber?:string, lotCodeOpsId?:number){
        this.lotCodeOpsId = lotCodeOpsId;
        this.lotNumber = lotNumber;
        this.subLotNumber = subLotNumber;
    }
}